import { render } from "./AddQuestionToQuizModal.vue?vue&type=template&id=8d06f8b8&scoped=true&ts=true"
import script from "./AddQuestionToQuizModal.vue?vue&type=script&lang=ts"
export * from "./AddQuestionToQuizModal.vue?vue&type=script&lang=ts"

import "./AddQuestionToQuizModal.vue?vue&type=style&index=0&id=8d06f8b8&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d06f8b8"]])

export default __exports__